"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var bistate_1 = require("bistate");

exports.mutate = bistate_1.mutate;
exports.remove = bistate_1.remove;

var react_2 = require("bistate/react");

exports.useComputed = react_2.useComputed;
exports.useBinding = react_2.useBinding;

var formater_1 = require("./formater");

var tracing = false;

exports.enableTracing = function () {
  tracing = true;
  formater_1.enableProxyFormater();
};

exports.disableTracing = function () {
  tracing = false;
  formater_1.disableProxyFormater();
};

var createTracer = function createTracer(f, name) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var start = tracing ? new Date() : null;
    var infoItem = {
      name: name || f.name || '',
      func: f,
      args: args,
      start: start,
      end: null
    };
    info.actions.push(infoItem);

    try {
      return f.apply(void 0, __spread(args));
    } finally {
      infoItem.end = new Date();
    }
  };
};

exports.useAction = function (f, options) {
  var callback = react_1.useMemo(function () {
    if (tracing) {
      if (options) {
        return createTracer(f, options.name);
      } else {
        return createTracer(f);
      }
    } else {
      return f;
    }
  }, [f, options ? options.name : null]);
  var action = react_2.useMutate(callback);
  return action;
};

var timer = null;
var info = {
  actions: [],
  mutations: []
};

var showInfo = function showInfo() {
  var actions = info.actions,
      mutations = info.mutations; // reset info

  info = {
    actions: [],
    mutations: []
  };
  var time = actions.reduce(function (acc, item) {
    return acc + (item.end.getTime() - item.start.getTime());
  }, 0);
  var start = actions.reduce(function (target, curr) {
    return target.start.getTime() < curr.start.getTime() ? target : curr;
  }, {
    start: new Date()
  }).start;
  var name = actions.map(function (item) {
    return item.name;
  }).filter(Boolean).join(', ');
  console.groupCollapsed((name || 'ACTION') + " takes " + time + "ms invoked at " + start.toLocaleString());
  console.info("%c action-list", "color: #4CAF50; font-weight: bold", actions.map(function (item) {
    return item.func;
  }));

  for (var i = 0; i < mutations.length; i++) {
    var _a = mutations[i],
        prev = _a.prev,
        next = _a.next;
    console.info("%c --------------------------", "color: #9E9E9E; font-weight: bold");
    console.info("%c [" + (i + 1) + "] prev-state", "color: #03A9F4; font-weight: bold", prev);
    console.info("%c [" + (i + 1) + "] next-state", "color: #03A9F4; font-weight: bold", next);
  }

  console.groupEnd();
};

exports.useReactive = function (initialState) {
  var state = react_2.useBistate(initialState);
  var stateRef = react_1.useRef(state);
  react_1.useEffect(function () {
    if (state === stateRef.current) return;
    if (!tracing) return;
    info.mutations.push({
      prev: stateRef.current,
      next: state
    });
    stateRef.current = state;
    clearTimeout(timer);
    timer = setTimeout(showInfo);
  }, [state]);
  return state;
};

exports.isReactive = bistate_1.isBistate;

exports.createStore = function (defaultData, options) {
  var Context = options ? options.Context : react_1.default.createContext(null);

  var Provider = function Provider(_a) {
    var _b = _a.initialData,
        initialData = _b === void 0 ? defaultData : _b,
        children = _a.children;
    var data = exports.useReactive(initialData);
    return react_1.default.createElement(Context.Provider, {
      value: data
    }, children);
  };

  var useData = function useData() {
    var data = react_1.useContext(Context);

    if (data === null) {
      throw new Error('You may forgot add store to <Provider stores={[..., store]} />');
    }

    return data;
  };

  var useCreate = function useCreate(defaultData) {
    var store = react_1.useMemo(function () {
      var options = {
        Context: Context
      };
      return exports.createStore(defaultData, options);
    }, []);
    return store;
  };

  return {
    Provider: Provider,
    useData: useData,
    useCreate: useCreate
  };
};

exports.Provider = function (_a) {
  var _b = _a.stores,
      stores = _b === void 0 ? [] : _b,
      children = _a.children;

  for (var i = stores.length - 1; i >= 0; i--) {
    var store = stores[i];
    children = react_1.default.createElement(store.Provider, null, children);
  }

  return react_1.default.createElement(react_1.default.Fragment, null, children);
};